export const columns = [
  {
    title: "From",
    dataIndex: "from",
    key: "from",
    render: (value: number) => `${value} KD`,
  },
  {
    title: "To",
    dataIndex: "to",
    key: "to",
    render: (value: number) => `${value} KD`,
  },
  {
    title: "Bonus (%)",
    dataIndex: "bonusCoinsPercent",
    key: "bonusCoinsPercent",
    align: "right" as const,
  },
];
